import { FC } from 'react';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnyProps = any;

type ModalSlotState = {
  Component: FC<AnyProps>;
  name: string;
  props?: AnyProps;
};

type CreateModalStoreState = {
  modalSlots: ModalSlotState[];
  openModal: (Component: FC<AnyProps>, name: string, props?: AnyProps) => void;
  closeModal: (name: string) => void;
};

export const useCreateModalStore = create(
  immer<CreateModalStoreState>((set) => {
    return {
      modalSlots: [],
      openModal: (Component, name, props) => {
        set((state) => {
          // if modal with this name is already open, do nothing
          if (state.modalSlots.find((slot) => slot.name === name)) {
            return;
          }

          state.modalSlots.push({
            Component,
            name,
            props,
          });
        });
      },
      closeModal: (name) => {
        set((state) => {
          state.modalSlots = state.modalSlots.filter((slot) => slot.name !== name);
        });
      },
    };
  }),
);
